import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';

export const useApiConfigurationEmail = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const getEmailTemplates = async () => {
    return runApi('Configuration/getEmailTemplates', 'GET').then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const updateEmailTemplates = async (Id: number, Template: string) => {
    return runApi('Configuration/updateEmailTemplate', 'POST', null, { Id, Template }).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const updateEmailTemplateCom = async (Data: any) => {
    return runApi('Configuration/updateEmailTemplateCom', 'POST', null, Data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  return { getEmailTemplates, updateEmailTemplates, updateEmailTemplateCom };
};
